import "./gharnoList.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { DataGrid } from "@mui/x-data-grid";
import {
  Box,
  Button,
  MenuItem,
  Select,
  Typography,
  Paper,
  IconButton,
  Dialog,
  DialogTitle,
  DialogActions,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const GharNoList = () => {
  const userIdRedux = useSelector((state) => state.user.userId);
  const adminType = useSelector((state) => state.user.adminType);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();

  const [tolls, setTolls] = useState([]);
  const [selectedToll, setSelectedToll] = useState("");
  const [data, setData] = useState([]);
  const [deleteId, setDeleteId] = useState(null);

  const userId = adminType === "sAdmin" ? "1" : userIdRedux;

  // Fetch Toll List
  useEffect(() => {
    const fetchTolls = async () => {
      const res = await axios.get(
        `${BASE_URL}/api/tollName/findAllTollName/${userId}`,
      );
      setTolls(res.data);
    };
    fetchTolls();
  }, [userId]);

  // Fetch Ghar No List
  useEffect(() => {
    if (!selectedToll) return;

    const fetchGharNo = async () => {
      const res = await axios.get(
        `${BASE_URL}/api/gharNo/findAllGharNo/${userId}/${selectedToll}`,
      );
      setData(res.data);
    };

    fetchGharNo();
  }, [selectedToll, userId]);

  // Delete
  const handleDelete = async () => {
    await axios.delete(`${BASE_URL}/api/gharNo/deleteGharNo/${deleteId}`);
    setData(data.filter((item) => item._id !== deleteId));
    setDeleteId(null);
  };

  const columns = [
    { field: "gharNo", headerName: "Ghar No", width: 150 },
    { field: "gharOwnerName", headerName: "Owner Name", width: 200 },
    { field: "createdDate", headerName: "Created Date", width: 150 },
    {
      field: "action",
      headerName: "Actions",
      width: 150,
      renderCell: (params) => (
        <>
          {/* <IconButton
            color="primary"
            onClick={() =>
              navigate("/gharNo/newGharNo", {
                state: {
                  tollId: selectedToll,
                  editData: params.row,
                },
              })
            }
          >
            <EditIcon />
          </IconButton> */}

          <IconButton color="error" onClick={() => setDeleteId(params.row._id)}>
            <DeleteIcon />
          </IconButton>
        </>
      ),
    },
  ];

  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />

        <Box sx={{ padding: 4 }}>
          <Paper elevation={3} sx={{ padding: 4 }}>
            <Typography variant="h5" fontWeight="bold" gutterBottom>
              Ghar No List
            </Typography>

            <Select
              fullWidth
              value={selectedToll}
              onChange={(e) => setSelectedToll(e.target.value)}
              displayEmpty
              sx={{ mb: 2 }}
            >
              <MenuItem value="">Select Toll</MenuItem>
              {tolls.map((toll) => (
                <MenuItem key={toll._id} value={toll._id}>
                  {toll.tollName}
                </MenuItem>
              ))}
            </Select>

            <Button
              variant="contained"
              sx={{ mb: 3 }}
              onClick={() =>
                navigate("/gharNo/newGharNo", {
                  state: { tollId: selectedToll },
                })
              }
              disabled={!selectedToll}
            >
              Add Ghar No
            </Button>

            <Box sx={{ height: 500 }}>
              <DataGrid
                rows={data}
                columns={columns}
                getRowId={(row) => row._id}
                pageSize={10}
              />
            </Box>
          </Paper>
        </Box>

        <Dialog open={!!deleteId} onClose={() => setDeleteId(null)}>
          <DialogTitle>Are you sure you want to delete?</DialogTitle>
          <DialogActions>
            <Button onClick={() => setDeleteId(null)}>Cancel</Button>
            <Button color="error" onClick={handleDelete}>
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
};

export default GharNoList;
